import {trigger, transition, style, query, animate, stagger, animateChild, group} from '@angular/animations';

export const routerTransition =
  trigger('routerTransition', [
    transition('* <=> *', [
      query(':enter', style({opacity: 0}), {optional: true}),
      group([
        query(":enter", animate('1s',
          style({opacity: 1})
        ), {optional: true})
      ])
      //,
      //animateChild()
    ])
  ]);
